export const Menus = {
    Author: '作成者情報',
    Testament: '遺言者登録',
    Heiress: '相続人',
    Money: '現金',
    Deposit: '預貯金',
    Land: '不動産(土地)',
    Building: '不動産(建物)',
    Apartment: '不動産(マンション等)',
    Stock: '国債・株式・社債',
    Fund: '投資信託',
// Insurance: '保険金・保険契約の解約払戻金',
    Bond: '債権',
// Debt: '債務',
    Automobile: '自動車',
    Other: 'その他'
}

export const People = {
    Author: '作成者情報'
}

export const People2 = {
    Author: '作成者情報',
    Testament: '遺言者登録',
    Heiress: '相続人'
}

export const Properties = {
    Money: '現金',
    Deposit: '預貯金',
    Land: '不動産(土地)',
    Building: '不動産(建物)',
    Apartment: '不動産(マンション等)',
    Stock: '国債・株式・社債',
    Fund: '投資信託',
// Insurance: '保険金・保険契約の解約払戻金',
    Bond: '債権',
// Debt: '債務',
    Automobile: '自動車',
    Other: 'その他'
}

export const MenuSteps = [
    '個人情報に関する入力',
    '財産に関する入力',
    '出力',
];

export const PersonSteps = [
    '作成者情報',
    '遺言者登録',
    '相続人登録',
];

export const PropertySteps = [
    '現金',
    '預貯金',
    '不動産(土地)',
    '不動産(建物)',
    '不動産(マンション等)',
    '国債・株式・社債',
    '投資\n信託',
    '債権',
    '自動車',
    'その他'
];

export const PropertyStepNames = [
    'money',
    'deposit',
    'land',
    'building',
    'apartment',
    'stock',
    'fund',
    'bond',
    'automobile',
    'other'
];
